import React from 'react';
import ReactDOM from 'react-dom';
import IndexTabSwitch from '../PageNav/IndexTabSwitch';
import ToolsBar from '../ToolsBar/ToolsBar';
class IndexWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    getDomHeight(dom) {
        return ReactDOM.findDOMNode(dom) && ReactDOM.findDOMNode(dom).offsetHeight || 0;
    }

    widgetsHeight() {
        return { toolsBar: this.getDomHeight(this.refs.toolsBar),hideItem: this.getDomHeight(this.refs.hideItem) };
    }

    closePop() {
        this.refs.toolsBar && this.refs.toolsBar.closePopUp();
    }

    changeStickyStyle(style) {
        if(this.refs.hideItem) {
            const { position, transform = `translateY(-${this.widgetsHeight().hideItem}px)`, holderHeight = `${this.widgetsHeight().toolsBar}px` } = style;
            const stickyStyle = this.refs.sticky.style;
            stickyStyle.willChange = 'position, transform, -webkit-transform';
            stickyStyle.position = position;
            stickyStyle.transform = transform;
            stickyStyle.WebkitTransform = transform;
            this.props.changeHolderHeight && this.props.changeHolderHeight(holderHeight); //顶部栏隐藏定位后，占位元素高
        }
    }

    renderToolsBar() {
        const { actions,reloadTable,getSearchCondition,isIndexPop } = this.props;
        const { status, Dashboard: chartData, TableList = {}, SearchForm: searchFormData } = this.props.indexData;
        let searchData = {}; // 筛选条件
        let sortColumns = []; // 所有排序项
        let sortData = [];
        const tableData = TableList.cmp_data || {};
        if(status !== 'loading') {
            if(tableData) {
                sortData = tableData.sort_fields;
                TableList.sub_cmps.map(cmp => {
                    if(cmp.cmp_data.sortable) {
                        sortColumns.push(cmp.cmp_data);
                    }
                });
            }
            searchData = getSearchCondition();
            return (
                <ToolsBar ref="toolsBar"
                        sortData={sortData}
                        reloadTable={reloadTable}
                        sortColumns={sortColumns}
                        searchData={searchData}
                        searchFormData={searchFormData}
                        chartData={isIndexPop ? null : chartData}
                        actions={actions}
                        tableData={tableData}
                />
            );
        }
        return null;
    }

    render() {
        const { style,indexData,actions,viewActived,currentViewIsCustomComponent } = this.props;
        return (<div className="sticky" ref="sticky">
                        {this.props.isTabView ?
                            <IndexTabSwitch
                                ref="hideItem"
                                tabstyle={style}
                                {...indexData.NavView}
                                actions={actions}
                                viewActived={viewActived}
                            /> : null}
                        {currentViewIsCustomComponent ? null : this.renderToolsBar()}
                </div>);
    }
       
}

IndexWidget.defaultProps = {
    indexData: {}
};
export default IndexWidget;



// WEBPACK FOOTER //
// ./src/components/Pages/IndexWidget.js